<div class="modal-content" cdkTrapFocus [cdkTrapFocusAutoCapture]="false">
  <div class="modal-header">
    <h1 class="modal-title pull-left" aria-hidden="true">
      {{ title | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="modal-body">
    <h2 class="page-header sr-only" role="heading" aria-level="1">
      {{ title | globalTranslate }}
    </h2>
    <p>{{ "HEALTH_PLAN_CANCEL_ERROR_TEXT_01" | globalTranslate }}</p>
    <p [innerHTML]="'HEALTH_PLAN_CANCEL_ERROR_TEXT_02' | globalTranslate"></p>
  </div>
  <div class="modal-footer justify-content-start">
    <div class="me-2 ml-2">
      @if (showConfirm) {
      <button
        type="button"
        [attr.aria-label]="'RETURN_TO_HEALTH_PLAN_DETAILS' | globalTranslate"
        id="dialog"
        class="btn d-grid btn-link"
        (click)="onConfirm()"
      >
        {{ confirmButton | globalTranslate }}
      </button>
      }
    </div>
  </div>
</div>